module.exports = __webpack_public_path__ + "static/media/line.8d5e2141.jpg";